/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import EventService from '../../../../services/EventService';
import calenderSvg from '../../../../public/calender.svg';
import moment from "moment";
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class MyEvents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventList: [],
      filteredList: []
    };
  }

  componentDidMount = () => { this.getEventList(); };

  getEventList = () => {
    EventService.getEventListByCountry({ 'blog_id': userData.blog_id.userblog_id })
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ eventList: result });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  eventType = (type) => {
    let filteredList = [];
    this.state.eventList.map((item, index) => {

      switch (type) {
        case 1://all
          filteredList = this.state.eventList;
          this.setState({ filterPincode: '' });
          break;
        case 2://pending
          item.post_status === "pending" && filteredList.push(item);
          break;
        // case 3://approved
        //   item.post_status === "publish" && filteredList.push(item);
        //   break;
        case 4://upcoming
          moment(item.start_date).isSameOrAfter(moment(), 'day') && item.post_status === 'publish' && filteredList.push(item);
          break;
        // case 5://pincode
        //   item.pincode === this.state.filterPincode && filteredList.push(item);
        //   break;
        // case 6://domain
        //   this.setState({ selectedCategory: categoryId }),
        //     item.category?.length > 0 && item.category?.map((item1, index) => (item1.name === categoryId && console.log("demo===", item, item1.name, categoryId) && filteredList.push(item)));
        //   break;
      }
    });

    this.setState({ filteredList });
  };

  render() {
    const { eventList, filteredList } = this.state;
    const finalEventList = filteredList.length > 0 ? filteredList : eventList;
    return (
      <div className="container pt-2">
        {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
            <li className="breadcrumb-item active" aria-current="page">My Events</li>
          </ol>
        </nav> */}
        <div className="row evhgrn p-2 mt-5 mb-3 rounded rounded-2">
          <div className="col-md-10 head-title">
            <h4 className="t0">My Events, <span className="linear-title gradd">{userData.blog_id.blogname}</span></h4>
            <p className="t2">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus
            </p>
          </div>
          <div className="col-md-2 d-flex align-items-center justify-content-center">
            <Link to="/add-practitioner-events" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn">
              {/* <i className="fa fa-plus-circle" aria-hidden="true"></i> */}
              Add New Event
            </Link>
          </div>
          <hr></hr>
          {/* <div className="col-12">
            <div className="row">
              <span className="text-secondary d-block mb-2">
                <i className="fa fa-filter" aria-hidden="true" /> Filter Events
              </span>
              <div className="col-4">
                <div className="form-group mb-4 position-relative has-search">
                  <span className="fa fa-search form-search"></span>
                  <input type="text" className="form-control pd-tb-675em" name="eventname" placeholder="Search By Event Name" />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="eventname" className="form-label over-label2">Date of Event</label>
                  <input type="date" className="form-control"
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group mb-4 position-relative">
                  <select className="form-select pd-tb-675em" aria-label="select city">
                    <option value="" selected disabled>Search By City</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="row bg-light p-2 mt-5 mb-3 rounded rounded-2">
          <div className="col-12">
            <ul className="nav nav-tabs alleventtabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#upcoming-events-pane" type="button" role="tab" onClick={() => this.eventType(1)} aria-controls="upcoming-events-pane" aria-selected="true">All Events</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" onClick={() => this.eventType(4)} data-bs-toggle="tab" data-bs-target="#upcoming-events-pane" type="button" role="tab" aria-controls="upcoming-events-pane" aria-selected="true">Upcoming events</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#upcoming-events-pane" type="button" role="tab" onClick={() => this.eventType(2)} aria-controls="events-awaiting-pane" aria-selected="false">Pending <span className="badge text-bg-secondary rounded-circle p-2"></span></button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="upcoming-events-pane" role="tabpanel" >
                <div className="row mt-4">
                  <div className="col-12 mb-4">
                    <div id="carousel" className="carousel slide" data-ride="carousel">
                      <ol className="carousel-indicators">
                        <li data-target="#carousel" data-slide-to="0" className="active bg-secondary"></li>
                        <li data-target="#carousel" data-slide-to="1" className="bg-secondary"></li>
                        <li data-target="#carousel" data-slide-to="2" className="bg-secondary"></li>
                      </ol>
                      <div className="carousel-inner">
                        <div className="carousel-item active">
                          <div className="row ">
                            {finalEventList.map((item, index) =>
                              // event card start
                              <div className="col-md-3 mb-4 redpadd" key={index}>
                                <div className="card p-3 event-card crdev">
                                  <div className="imgrel">
                                    <Link to={{
                                      pathname: "/event-practitioner-details",
                                      search: `?id=${item.ID}`,
                                      state: { eventDetails: item }
                                    }}>
                                      <img src={item.image_upload[0]} className="img-fluid card-img-top rounded" alt="events" /></Link>
                                    <div className="card-img-overlay crdvw">
                                      {/* <Link to='/' className="btn btn-light btn-sm info-tag lnkst"> <i className="fa fa-eye" aria-hidden="true" /> 132 Public Views</Link> */}
                                    </div>
                                  </div>
                                  <div className="card-body px-0 crdbod">
                                    <span className="crttxx">
                                      <h5 className="card-title crttl fs-5 fw-bold nomar crop-text">{item.post_title}</h5>
                                      <h6 className="card-subtitle crdate text-muted nomar">Date : {moment(item.start_date).format("Do MMM YYYY")}</h6>
                                      <p className="card-text nomar crpara crop-text">{item.post_content} </p>
                                    </span>
                                  </div>
                                </div>
                                <div className={item.post_status === "pending" ? "crbotm_red" : "crbotm"}>
                                  <p className="dtpr">Created - <span className="cdte">{moment(item.post_date).format("Do MMM YYYY")}</span></p>
                                  <span className="dtpr">/</span>
                                  <p className="dtpr">{` Event On - `}<span className="cdte">{moment(item.start_date).format("Do MMM YYYY")}</span></p>
                                </div>
                              </div>)}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* below is the pagination for events */}
        {/* <div className="col-12 d-flex justify-content-center mt-4">
          <nav aria-label="Page navigation">
            <ul className="pagination eve-pagination">
              <li>
                <Link to='/' aria-label="Previous">
                  <span aria-hidden="true"><i className="fa fa-chevron-left" aria-hidden="true"></i></span>
                </Link>
              </li>
              <li className="active"><Link to="/">01</Link></li>
              <li><Link to="/">02</Link></li>
              <li><Link to="/">03</Link></li>
              <li><Link to="/">04</Link></li>
              <li><Link to="/">05</Link></li>
              <li><Link to="/">06</Link></li>
              <li><Link to="/">07</Link></li>
              <li><Link to="/">08</Link></li>
              <li><Link to="/">09</Link></li>
              <li><Link to="/">10</Link></li>
              <li>
                <Link to='/' aria-label="Next">
                  <span aria-hidden="true"><i className="fa fa-chevron-right" aria-hidden="true"></i></span>
                </Link>
              </li>
            </ul>
          </nav>
        </div> */}
      </div>
    );
  }
}
export default MyEvents;